import { module } from 'stereomodularjs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.label = this.el.querySelector('.o-custom-select__label');
        this.fakeOptions = this.el.querySelectorAll('.o-custom-select__option');
        this.realSelect = this.el.querySelector('select');

        this.fakeOptions.forEach((option) => {
            option.addEventListener('click', (e) => {
                this.onOptionClick(option);
            });
        });

        this.realSelect.addEventListener('change', (e) => {
            this.onRealSelectChange();
        });
    }

    onOptionClick(option) {
        const value = option.getAttribute('data-value');
        this.label.innerHTML = option.innerHTML;
        this.realSelect.querySelector(`option[value="${value}"]`).selected = true;
        this.realSelect.dispatchEvent(new Event('change'));
        this.realSelect.classList.add('is-changed');
        setTimeout(() => {
            this.realSelect.classList.remove('is-changed');
        }, 2000);
    }

    onRealSelectChange() {
        const selectedValue = this.realSelect.value;
        this.fakeOptions.forEach((option) => {
            if (option.getAttribute('data-value') === selectedValue) {
                this.label.innerHTML = option.innerHTML;
            }
        });
    }

    destroy() {
        this.fakeOptions.forEach((option) => {
            option.removeEventListener('click');
        });
        this.realSelect.removeEventListener('change');
    }
}
